/**
 * Generated from https://www.caesars.com/api/v1/markets
 * with https://quicktype.io and QuickType VSCode Plugin.
 */

export type Markets = Market[];

export interface Market {
  name: string;
  id: string;
  url?: string;
  summary: string;
  bookingUrl: string;
  isSearchable: boolean;
  thumbnail?: FeaturedImage;
  featuredImage?: FeaturedImage;
  ibeHeaderImage?: FeaturedImage;
  logo?: FeaturedImage;
  location?: Location;
}

export interface FeaturedImage {
  url: string;
}

export interface Location {
  latitude: number;
  longitude: number;
  minLatitude: number;
  maxLatitude: number;
  minLongitude: number;
  maxLongitude: number;
}

/**
 * List of known market codes mapped to a readable name
 *
 * Notes:
 *   'ohm', // Ohio Market, a market that used to exist, but no longer does
 */
export enum MarketCodeEnums {
  ATLANTIC_CITY = 'acm',
  LAS_VEGAS = 'lvm',
  BOSSIER_CITY = 'bos',
  COUNCIL_BLUFFS = 'iam',
  GULF_COAST = 'gcm',
  LAKE_TAHOE = 'ltm',
  TUNICA = 'nmm',
  BALTIMORE = 'baltimore', //  - Non bookable market
  OTHER = 'oth',
  RENO = 'rnm',
  LAUGHLIN = 'lnv',
  INTERNATIONAL = 'int',
}

export const MARKET_SORT_ORDER: string[] = [
  MarketCodeEnums.LAS_VEGAS,
  MarketCodeEnums.ATLANTIC_CITY,
  MarketCodeEnums.RENO,
];
